module.exports = __webpack_public_path__ + "static/3.3-ca12aa246a5e3400b57a2e5a8021f0e7.jpg";